const e = "cmp", n = otto[e], {
  allowAll: t,
  rejectAll: o,
  togglePreferenceCenter: s,
  resurfaceBanner: r,
  rejectGeneralVendorConsent: C,
  getConsentForGV: c,
  getConsentsForAllGVs: a,
  getIabConsentString: g,
  readVendorsConsents: l,
  readConsentsStates: p,
  archiveReceipt: d,
  emitConsentChangeEvent: A,
  getOttoOwnPurposesConsent: i,
  getAppGoogleTrackingConsent: V,
  getAdjustTrackingConsent: h,
  processAppConsentV2: u,
  consentChanged: E,
  onetrustLoaded: G,
  showVendorsList: P
} = otto[e];
export {
  e as NEXUS_CMP_NAMESPACE,
  t as allowAll,
  d as archiveReceipt,
  n as cmp,
  E as consentChanged,
  A as emitConsentChangeEvent,
  h as getAdjustTrackingConsent,
  V as getAppGoogleTrackingConsent,
  c as getConsentForGV,
  a as getConsentsForAllGVs,
  g as getIabConsentString,
  i as getOttoOwnPurposesConsent,
  G as onetrustLoaded,
  u as processAppConsentV2,
  p as readConsentsStates,
  l as readVendorsConsents,
  o as rejectAll,
  C as rejectGeneralVendorConsent,
  r as resurfaceBanner,
  P as showVendorsList,
  s as togglePreferenceCenter
};
